module.exports = __webpack_public_path__ + "img/bus-blue.067a8b73.svg";